import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import MapView from '@arcgis/core/views/MapView';
import { MapBaseConfig } from '../../models/dashboard-config';

@Injectable({
  providedIn: 'root',
})
export class MapViewService {
  private mapViewSubject = new BehaviorSubject<MapView | null>(null);
  private mapConfigSubject = new BehaviorSubject<MapBaseConfig | null>(null);

  mapView$ = this.mapViewSubject.asObservable();
  mapConfig$ = this.mapConfigSubject.asObservable();

  setMapView(view: MapView | null) {
    this.mapViewSubject.next(view);
  }

  setMapConfig(config: MapBaseConfig) {
    this.mapConfigSubject.next(config);
  }

  getMapView(): MapView | null {
    return this.mapViewSubject.value;
  }

  getMapConfig(): MapBaseConfig | null {
    return this.mapConfigSubject.value;
  }
}
